const hostname = window.location.hostname
const port = process.env.PORT || 3001
const appUrl = process.env.REACT_APP_URL || "http://:webshophost:" + port

module.exports = {
	APP_URL: `${appUrl.replace(':webshophost', hostname)}`,
	STORE_BASE_URL: `${process.env.REACT_APP_INTERNAL_API_URL.replace(':host', 'p:id')}`,
  FETCH_SHOP_URL: `${process.env.REACT_APP_INTERNAL_API_URL.replace(':host', 'api')}/api/v2/webshop/${hostname}`
}
